import { Calendar, TasksQueryParams } from '@nextforce/api'

const keys = {
  all: ['tasks'] as const,
  list: (calendar: Calendar | undefined, params: TasksQueryParams) =>
    [...keys.all, calendar, params] as const,
  details: () => [...keys.all, 'detail'] as const,
  detail: (id?: string, fromDate?: string, toDate?: string) =>
    [...keys.details(), id, fromDate, toDate] as const,
}

export default keys
